import React, {
  createContext,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import { Toast, ToastMessageOptions } from 'primereact/toast';

import { ToastContextType, ToastProviderProps } from './types';

const ToastContext = createContext<ToastContextType>({
  showToast: () => null,
});

export function ToastProvider({ children }: Readonly<ToastProviderProps>) {
  const toast = useRef<Toast>(null);

  const showToast = useCallback((options: ToastMessageOptions) => {
    if (toast.current) {
      toast.current.show(options);
    }
  }, []);

  const memoizedValue = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={memoizedValue}>
      <Toast ref={toast} />
      {children}
    </ToastContext.Provider>
  );
}

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
};
